module.exports = __webpack_public_path__ + "static/media/storeIcon.37924560.svg";